import type { MechKey } from './keys';

export const tr: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Mekanik · 2D',
  'panel.scene': 'Sahne',
  'panel.dims': 'Parametreler',
  'panel.style': 'Görünüm',
  'panel.action': 'Denetimler',
  'style.body': 'Cisim',
  'style.vector': 'Vektörler',
  'style.ground': 'Zemin',
  'style.forces': 'Kuvvetleri göster',
  'style.trace': 'İzi göster',
  'style.labels': 'Vektör etiketleri',
  'hint.line1': "Başlatmak için oynat'a tıklayın · cisimleri sürükleyin",
  'hint.line2': 'Sandbox: bir şekil seçin, sonra yerleştirmek için tıklayın',
  'scene.incline': 'Eğik düzlem',
  'scene.projectile': 'Atış hareketi',
  'scene.pendulum': 'Sarkaç',
  'scene.springMass': 'Yay-kütle sistemi',
  'scene.collisions': 'Çarpışmalar',
  'scene.atwood': 'Atwood makinesi',
  'scene.circular': 'Dairesel hareket',
  'scene.sandbox': 'Sandbox',
  'dim.angle': 'açı (°)',
  'dim.friction': 'sürtünme',
  'dim.mass': 'kütle',
  'dim.massA': 'kütle A',
  'dim.massB': 'kütle B',
  'dim.velocity': 'hız',
  'dim.angleLaunch': 'fırlatma açısı (°)',
  'dim.gravity': 'yerçekimi',
  'dim.gravityX': 'yerçekimi x',
  'dim.gravityY': 'yerçekimi y',
  'dim.length': 'uzunluk',
  'dim.damping': 'sönümleme',
  'dim.spring': 'sertlik',
  'dim.restitution': 'geri yansıma katsayısı',
  'dim.radius': 'yarıçap',
  'dim.speed': 'hız büyüklüğü',
  'action.play': 'Oynat',
  'action.pause': 'Duraklat',
  'action.step': 'Adım',
  'action.reset': 'Sıfırla',
  'action.speed': 'Hız',
  'action.clear': 'Temizle',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Yerçekimi',
  'forceName.normal': 'Normal kuvvet',
  'forceName.friction': 'Sürtünme kuvveti',
  'forceName.tension': 'Gerilme',
  'forceName.spring': 'Yay kuvveti',
  'forceName.applied': 'Uygulanan kuvvet',
  'forceName.air': 'Hava direnci',
  'palette.box': 'Kutu',
  'palette.circle': 'Top',
  'palette.ramp': 'Rampa',
  'palette.ground': 'Zemin',
  'palette.hint': 'Bir şekil seçin, ardından yerleştirmek için tuval üzerine tıklayın.',
  'panel.forces': 'Gözlemlenen kuvvetler',
  'forces.empty': 'Henüz yok — sahneyi oynatın',
};
